/**
 * @name store/modules/auth.js
 * @module app
 *
 * @description
 * The typescript store modules.
 *
 * @project spotgig4web
 * @author Ryunosuke Oguri on 2017/12/13
 * Copyright © 2017年 Axis-motion. All rights reserved.
 */
import Mypage from '@/api/v1/mypage';
import * as types from './mutation-types';
import { ACCESS_TOKEN_KEY } from "@/constants/localStorageKeys";

// initial state
const state = {
  worker: null
}

// getters
const getters = {
  mine: state => state.worker,
}

// actions
const actions = {
  fetchMine({ commit }, params) {
    return new Promise((resolve, reject) => {
      Mypage.get(params, (response) => {
        if (response.status === 200) {
          commit(types.SET_MINE, response.data.payload);
          resolve();
        } else {
          reject(response.data.errors);
        }
      });
    });
  },
  setToken ({ commit }, payload) {
    commit(types.SET_TOKEN, payload.access_token);
  },
}

// mutations
const mutations = {
  [types.SET_MINE] (state, payload) {
    state.worker = payload;
  },
  [types.SET_TOKEN] (_state, payload) {
    localStorage.setItem(ACCESS_TOKEN_KEY, payload);
  },
  [types.CLEAR_TOKEN] (_state, _payload) {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
